import { connect } from 'react-redux'
import InputFile from './InputFile'
import SelectRegion from './SelectRegion'
import LoadedFile from './LoadedFile'
import './ProfileDS.css'
import { base_url } from '../api/index'
import { getRegions } from '../actions/dictionary'
import { updateUser } from '../actions/user'
import { openSnackbar } from '../actions/snackbar'

function ProfileDS({ user, regions, getRegions, openSnackbar, updateUser }) {
    const userStatus = user.status
    const isUserConfirmed = userStatus === 'confirmed' ? true : false
    const role = user.role
    const onload = () => {
        window.addEventListener('message', message, false)
    }

    const message = (e) => {
        if (e.origin === `https://hcvf.citorus.ru:8889`) {
            // const data = JSON.parse(e.data)
            // if (data.name === 'profile-ds') {
            //     updateUser(data.user)
            //     setFiles([])
            // }
            // else if (data.error === true) {
            //     openSnackbar(data.msg, "error")
            //     return;
            // } else if (data.error === false) {
            // }
        }
    }

    return (
        <>
            {isUserConfirmed && role === 'e249a07138dd45d3f4ba27d90d6c2244d' &&
               <iframe sandbox="allow-same-origin allow-scripts" id="iframeAuth" onLoad={onload} name="iframeAuth" src="https://hcvf.citorus.ru:8889/public/profile_ds" style={{ position: 'absolute', width: 0, height: 0, border: 'none' }}></iframe>
            }

            {isUserConfirmed && role !== 'e249a07138dd45d3f4ba27d90d6c2244d' &&
                <p>Страница доступна только пользователям роли 'Держатель сертификата FSC'</p>}
            {userStatus === 'unregistered' &&
                <p>Страница доступна только авторизованным пользователям роли 'Держатель сертификата FSC'</p>}
        </>
    )
}

const mapStateToProps = state => ({
    user: state.user,
    regions: state.dictionary.regions
})

export default connect(mapStateToProps, { getRegions, openSnackbar, updateUser })(ProfileDS)